import { Box, Divider, Grid, Modal, Typography } from '@mui/material'
import React from 'react'
import { TextBold, TextRegular } from '../../../../commonComponents/TextStyling'
import { useTheme } from '@mui/material/styles'
import CloseIcon from '@mui/icons-material/Close'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 5,
  p: 2,
  width: '85%',
  height: '90vh',
  overflowY: 'auto'
}

export default function JobPostPreviewModal ({ data }) {
  var theme = useTheme()
  var {
    open,
    company,
    jobDescription,
    title,
    type,
    jobFunction,
    industry,
    experienceLevel,
    education,
    compensationFrom,
    compensationTo,
    state,
    country,
    zipCode,
    skill,
    experienceYears,
    experienceMonths,
    onClose
  } = data

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <CloseIcon
          onClick={onClose}
          style={{
            position: 'absolute',
            right: 4,
            top: 4,
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.background.paper,
            borderRadius: 20,
            fontSize: '24px',
            cursor: 'pointer'
          }}
        />
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          align='left'
          fontWeight={'bold'}
        >
          {company}
        </Typography>

        <Divider
          fullWidth
          style={{ width: '100%', marginTop: '12px', marginBottom: '12px' }}
        />
        <Typography
          id='modal-modal-description'
          sx={{ mt: 2 }}
          style={{ whiteSpace: 'pre-line' }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6.8}>
              <Grid item xs={12}>
                <TextRegular style={{ fontSize: '22px', fontWeight: 300 }}>
                  Job description
                </TextRegular>
              </Grid>
              <Grid item xs={12}>
                <Box
                  dangerouslySetInnerHTML={{
                    __html: jobDescription
                  }}
                />
              </Grid>
            </Grid>
            <Grid item xs={0.2}>
              <Divider
                orientation='vertical'
                fullWidth
                style={{ width: '100%' }}
              />
            </Grid>
            <Grid item xs={5}>
              <Grid item xs={12}>
                <TextRegular style={{ fontSize: '22px', fontWeight: 300 }}>
                  About Job
                </TextRegular>
              </Grid>
              <Grid item xs={12} style={{ margin: '16px' }}>
                <Grid container spacing={1} style={{ lineHeight: '36px' }}>
                  <Grid item xs={6}>
                    <TextBold>Job Title:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>{title}</TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Job Type:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>{type}</TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Job function:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>{jobFunction}</TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Industry:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>{industry}</TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Experience level:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>{experienceLevel}</TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Education level:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>{education}</TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Compensation:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>
                      {compensationFrom}-{compensationTo}
                    </TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Location:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>
                      {state},{country}
                    </TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />
                  <Grid item xs={6}>
                    <TextBold>Zip code:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>{zipCode}</TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Skills:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>{skill}</TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />

                  <Grid item xs={6}>
                    <TextBold>Experience required:</TextBold>
                  </Grid>
                  <Grid item xs={6}>
                    <TextRegular>
                      {experienceYears} Years, {experienceMonths} Months
                    </TextRegular>
                  </Grid>
                  <Divider fullWidth style={{ width: '100%' }} />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Typography>
      </Box>
    </Modal>
  )
}
